import React, { useState } from 'react'
import GridCell from './GridCell'
import itemInArrObjsByValue from 'helpers/itemInArrObjsByValue'
import { useTranslation } from 'react-i18next'
import { Backwards, Forward } from './StyledNavButtons'
import { StyledGrid, StyledNavBar } from './StyledCategoryGrid'

const GridGenerator = ({ data, dimensions: [h = 5, w = 5] = [], onDrop, onRemove, categoryName, readOnly }) => {
	const pagesPerNavPage = 8
	const [t] = useTranslation()
	const [page, setPage] = useState(0)
	const [navPage, setNavPage] = useState(0)

	const positionArr = [...data.map(i => i?.position), 1]
	const pagesCount = Math.ceil(Math.max.apply(Math, positionArr) / 100) + 1
	const isLastPage = pagesCount <= (navPage + 1) * pagesPerNavPage

	const navcontent = Array(pagesPerNavPage).fill().map((_, i) => {
		const pageIndex = navPage * pagesPerNavPage + i
		return {
			name: `${t('category_section.strings.grid_page')} ${pageIndex + 1}`,
			action: () => setPage(pageIndex),
			active: page === pageIndex
		}
	})

	if(!isLastPage) {
	 	navcontent.push({
			Component: Forward,
			action: () => setNavPage(prevPage => prevPage + 1)
		})
	}
	if(navPage > 0) {
		navcontent.unshift({
			Component: Backwards,
			action: () => setNavPage(prevPage => prevPage - 1)
		})
	}

	const cellWidth = 122

	return(
		<StyledNavBar
			label={t('category_section.strings.grid_category')}
			navContent={navcontent}
		>
			<StyledGrid>
				<div style={{ width: `${cellWidth * w}px` }}>
					{Array(h * w).fill().map((c, i) => {
						const cellNum = i + 1 + 100 * page
						const cellData = itemInArrObjsByValue(cellNum, data, 'position')
						const cellProps = {
							onDrop,
							onRemove,
							readOnly,
							key: `${cellNum} ${cellData ? cellData.mod_ver : 'noData'}`,
							data: cellData,
							// currency: 'CHF',
							cellNum: cellNum
						}
						return <GridCell {...cellProps}/>
					})}
				</div>
			</StyledGrid>
		</StyledNavBar>
	)
}

export default GridGenerator
